<template>
  <v-container 
    fluid
    style="display: flex; justify-content: center; align-items: center; height: 100%; flex-direction: column; position: relative;"
  >
  <v-alert
    color="orange"
    outlined
    dismissible
    type="info"
    style="background-color: rgba(254,250,235,0.95) !important; position: absolute; top: 5px; width: 100%; z-index: 10;"
  >
  <span><strong>This is Demo System</strong></span>
  <br>
  <span v-if="!showKr" @mouseover="showKr = true">
    This website is for demonstration purposes.
    At WIKI SECURITY, we deliver optimized security solutions by customizing both the architecture and functionality of this system according to your specific requirements - whether for Cloud, On-Premise, or Hybrid environments.
    When needed, we can also customize our solution to integrate seamlessly with your existing system.
    <br><br>
    <strong>Contact ></strong> wikiadmin@wikisecurity.net, info@wikisecurity.net
  </span>

  <span v-if="showKr" @mouseout="showKr = false">
    이 웹사이트는 데모용입니다.
    WIKI SECURITY는 당신의 요구사항에 따라 이 시스템을 Cloud 또는 On-Premise 또는 Hybrid로 구성과 기능을 커스터마이징하여 당신에게 최적화된 솔루션으로 제공할수 있습니다. 또한, 경우에 따라서는 당신이 운영중인 다른 시스템과 연동하여 사용될수 있도록 커스터마이징 할수도 있습니다.
    <br><br>
    <strong>Contact ></strong> wikiadmin@wikisecurity.net, info@wikisecurity.net
  </span>

  </v-alert>
  <v-card elevation="0" id="introBox" class="pa-2" style="height: 100%; overflow: auto;" >
      <div @click="gotop" style="width: 50px; height: 50px; position: fixed; bottom: 10px; right: 10px; z-index: 1000;">
        <img src="@/assets/arrow-up-bold-circle.svg" class="gotop">
      </div>

     
      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium" style="padding-bottom: 0px;">WIKI-WS</v-card-title>
          <!-- <div class="pa-5" v-if="!overview1" @mouseover="overview1=true" style=" height: 7.5em;"> -->
          <div class="pa-5 pt-0" v-if="!overview1"  >
          <strong>Detect Real Web & API Compromise — Not Just Vulnerabilities</strong><br> 
          WIKI-WS is a Web & API Threat Scanner designed to detect not only application   
          vulnerabilities, but also real-world compromise indicators in live environments.  
          <br>Most scanners stop at identifying what 
          could
          be exploited.  
          WIKI-WS helps security teams understand what 
          <i>has already been exploited</i>
          </div>
          
          <!-- <div class="pa-5" v-if="overview1" @mouseout="overview1=false" style=" height: 7.5em;">
            이 강력한 웹 애플리케이션 스캐너는 50개 이상의 잘 알려진 취약점을 빠르게 스캔하여 4가지 심각도(High, Medium, Low, Information)로 분류합니다. 
            탐지된 각 취약점은 OWASP Top10, CWE, WASC 표준에 따라 분석되어 보안을 강화하기 위한 자세한 원인과 수정 단계를 제공합니다.
            이 스캐너는 당신의 웹 애플리케이션 보안을 강화하기 위한 최적의 선택입니다.
          </div> -->
        <!-- <v-card-title class="text-h6" style="padding-bottom: 0px;">1.2 Scan Policies</v-card-title> -->
        
      </div>
      
      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0">Why WIKI-WS Exists</v-card-title>
        <!-- <div class="pa-5" v-if="!rule" @mouseover="rule=true" style="height: 3.0em;"> -->
        <div class="pa-5 pb-0 pt-0" v-if="!rule">
          Modern services are built on complex architectures that rely heavily on APIs as well as   
          traditional web applications. <br>
          While this improves scalability and flexibility, it also significantly expands the attack   
          surface. <br>
          However, many security tools still focus primarily on:  
        </div>
        <div class="d-flex flex-column pa-7 pt-1 pb-1" >
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Web form–based vulnerability scanning  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Theoretical risks defined by vulnerability categories  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Pre-exploitation assessment only  
            </span>
          </div>
        </div>
         <div class="pa-5 pt-1" v-if="!rule">
          As a result, security teams often struggle to answer a critical operational question:  <br>
          “Is this web application or API already compromised?”  <br>
          WIKI-WS was created to answer that question clearly, quickly, and reliably.  
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0">What Is WIKI-WS  </v-card-title>
        <!-- <div class="pa-5" v-if="!rule" @mouseover="rule=true" style="height: 3.0em;"> -->
        <div class="pa-5 pb-0 pt-0" v-if="!rule">
          WIKI-WS is a Web & API Threat Scanner that combines:  
        </div>
        <div class="d-flex flex-column pa-7 pt-1 pb-1" >
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Web and API vulnerability scanning   
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Detection of real compromise indicators in production environments  
            </span>
          </div>
        </div>
        <div class="pa-5 pt-1" v-if="!rule">
          It is designed for security and operations teams who need immediate visibility into the   
          actual security state of their services—without requiring source code access or   
          complex forensic workflows.  
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0">What WIKI-WS Detects</v-card-title>
        <!-- <div class="pa-5" v-if="!rule" @mouseover="rule=true" style="height: 3.0em;"> -->
        <div class="pa-5 pb-0 pt-0" v-if="!rule">
         WIKI-WS goes beyond traditional vulnerability scanning. <br>
         It detects:  
        </div>
        <div class="d-flex flex-column pa-7 pt-1 pb-1" >
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; OWASP Top 10 web application vulnerabilities  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; API vulnerabilities aligned with OWASP API Security Top 10  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Cryptominers abusing web or API resources  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Webshells deployed after successful exploitation  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Backdoors and malicious scripts  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Traces of hacking tools targeting web and API endpoints  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Malware and virus infections  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; The exact files, scripts, or objects affected by an infection  
            </span>
          </div>
        </div>
        <div class="pa-5 pt-1" v-if="!rule">
          This allows teams to move directly from detection to remediation.  
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0" style="padding-bottom: 0px;">How WIKI-WS Is Different  </v-card-title>
          <!-- <div class="pa-5" v-if="!overview1" @mouseover="overview1=true" style=" height: 7.5em;"> -->
          <div class="pa-5 pb-0 pt-0 " v-if="!overview1"  >
            <strong>Web + API Coverage  </strong><br> 
            WIKI-WS scans both traditional web surfaces and modern API endpoints in a single platform.  
          </div>
          <div class="pa-5 pb-0 pt-2" v-if="!overview1"  >
            <strong>Threat-Oriented Detection   </strong><br> 
            Instead of focusing only on potential weaknesses, WIKI-WS identifies indicators of real compromise.   
          </div>
          <div class="pa-5 pb-0 pt-2" v-if="!overview1"  >
            <strong>Object-Level Visibility  </strong><br> 
            WIKI-WS does not simply report that an infection exists—it identifies what was infected and where.  
          </div>
          <div class="pa-5 pt-2" v-if="!overview1"  >
            <strong>Built for Live Environments  </strong><br> 
            No source code is required.<br>WIKI-WS is designed to operate safely against running, production services.  
          </div>
        
      </div>


      <div id="dev">
        <v-card-title class="text-h5 font-weight-medium pb-0" >How WIKI-WS Compares to Traditional Web Scanners  </v-card-title>
        <div class="pa-5 pt-0" v-if="!overview1"  >
          Traditional scanners focus primarily on identifying potential vulnerabilities. WIKI-WS   
          focuses on detecting real threats and compromise indicators in live web and API   
          environments.    
        </div>
        <div style="width: 100%; margin-bottom: 30px;" class="d-flex justify-center">
          <v-data-table
          :headers="headers"
          :items="items"
          style="width:75%; padding-bottom: 10px"
          :style="$vuetify.breakpoint.width<600?'width:100%;':''"
          hide-default-footer
          disable-sort
          dense
          >

            <template v-slot:[`item.ws`]="{item}">
              <v-icon v-if="item.ws === 'O'">
                mdi-check
              </v-icon>
              <span v-else>{{ item.ws }}</span>
            </template>
            <template v-slot:[`item.aa`]="{item}">
              <v-icon v-if="item.aa === 'O'">
                mdi-check
              </v-icon>
              <v-icon v-else-if="item.aa === 'X'">
                mdi-window-close
              </v-icon>
              <span v-else>
                {{ item.aa }}
              </span>
            </template>
          </v-data-table>
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0">Where WIKI-WS Fits  </v-card-title>
        <div class="d-flex flex-column pa-7 pt-0 pb-1" >
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Vulnerability scanners tell you where weaknesses may exist  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Incident response tools analyze incidents after escalation  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; WIKI-WS helps you quickly determine whether your web or API services are already compromised  
            </span>
          </div>
        </div>
        <div class="pa-5 pt-1" v-if="!rule">
          WIKI-WS bridges the gap between vulnerability assessment and full incident response.   
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <v-card-title class="text-h5 font-weight-medium pb-0">Common Use Cases  </v-card-title>
        <div class="pa-5 pb-0 pt-0" v-if="!rule">
         Security teams use WIKI-WS for:  
        </div>
        <div class="d-flex flex-column pa-7 pt-1" >
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Post-scan validation after regular web and API assessments  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Rapid compromise checks when suspicious activity is detected  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Security reviews of exposed APIs used by web and mobile applications  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Initial triage before engaging full incident response processes  
            </span>
          </div>
          <div>
            <span
                lang="EN-US"
                style="font-size: 10.5pt;line-height: 107%; font-family: Wingdings; color: #333333; "
                >l<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span>
                <span lang="EN-US" style="font-size: 16px; line-height: 107%; font-family: Roboto,sans-serif; color: #333333; background: white; "
                >&nbsp; Routine health checks of critical production services  
            </span>
          </div>
        </div>
      </div>


      <div style="margin-bottom: 30px; text-align: center;">
          <div class="pa-5" v-if="!overview1">
          <i>If your current tools only tell you what might be vulnerable, <br>
          WIKI-WS tells you what is actually happening in your web and API environment.<br>
          WIKI-WS brings real-world web and API threat visibility to security teams.</i>
          </div>
          
          <!-- <div class="pa-5" v-if="overview1" @mouseout="overview1=false" style=" height: 7.5em;">
            이 강력한 웹 애플리케이션 스캐너는 50개 이상의 잘 알려진 취약점을 빠르게 스캔하여 4가지 심각도(High, Medium, Low, Information)로 분류합니다. 
            탐지된 각 취약점은 OWASP Top10, CWE, WASC 표준에 따라 분석되어 보안을 강화하기 위한 자세한 원인과 수정 단계를 제공합니다.
            이 스캐너는 당신의 웹 애플리케이션 보안을 강화하기 위한 최적의 선택입니다.
          </div> -->
        <!-- <v-card-title class="text-h6" style="padding-bottom: 0px;">1.2 Scan Policies</v-card-title> -->
        
      </div>
    </v-card>
  </v-container>
</template>

<script>
import owaspList from "@/assets/owasp.json"

export default {
    name:'AboutMe',
    data:()=>({
      showKr:false,
      overview1:false,
      overview2:false,
      overview3:false,
      overview4:false,
      rule:false,
      // policies:[
      //   {
      //     type: 'Information Gathering',
      //     content: 
      //       `.env Information Leak<br>
      //       .htaccess Information Leak<br>
      //       Directory Browsing<br>
      //       ELMAH Information Leak<br>
      //       Heartbleed OpenSSL Vulnerability<br>
      //       Hidden File Finder<br>
      //       Remote Code Execution - CVE-2012-1823<br>
      //       Source Code Disclosure - /WEB-INF Folder<br>
      //       Source Code Disclosure - CVE-2012-1823<br>
      //       Spring Actuator Information Leak<br>
      //       Trace.axd Information Leak<br>
      //       User Agent Fuzzer`
      //   },
      //   {
      //     type: 'Injection',
      //     content:
      //       `Buffer Overflow<br>
      //       Cloud Metadata Potentially Exposed<br>
      //       CRLF Injection<br>
      //       Cross Site Scripting<br>
      //       Format String Error<br>
      //       Parameter Tampering<br>
      //       Remote OS Command Injection<br>
      //       Server Side Code Injection<br>
      //       Server Side Include<br>
      //       Server Side Template Injection<br>
      //       Spring4Shell<br>
      //       SQL Injection<br>
      //       XML External Entity Attack<br>
      //       XPath Injection<br>
      //       XSLT Injection`
      //   },
      //   {
      //     type: 'Miscellaneous',
      //     content: 
      //       `External Redirect<br>
      //       Generic Padding Oracle<br>
      //       GET for POST<br>
      //       Log4Shell<br>
      //       Script Active Scan Rules<br>
      //       SOAP Action Spoofing<br>
      //       SOAP XML Injection`
      //   },
      //   {
      //     type: 'Server Security',
      //     content: 
      //       `Path Traversal<br>
      //       Remote File Inclusion`
      //   },
      //   {
      //     type: 'Well-Known',
      //     content: 
      //       `CryptoMiner<br>
      //       Hacking Tool<br>
      //       Webshell<br>
      //       Backdoor<br>
      //       Obfuscation
      //       `
      //   },
      //   {
      //     type: 'Malware',
      //     content: 
      //       `Virus<br>`
      //   }
      // ],
      headers: [
        { text: 'Capability', value: 'capa' },
        { text: 'WIKI-WS', value: 'ws', align: 'center' },
        { text: 'Acune***/AppS***', value: 'aa', align: 'center' },
      ],
      items: [
        { capa: 'Web Vulnerability Scanning ', ws: 'O', aa: 'O' },
        { capa: 'API Vulnerability Scanning ', ws: 'O', aa: 'Partial' },
        { capa: 'OWASP Top 10 Coverage ', ws: 'O', aa: 'O' },
        { capa: 'Webshell Detection ', ws: 'O', aa: 'X' },
        { capa: 'Cryptominer Detection ', ws: 'O', aa: 'X' },
        { capa: 'Backdoor & Malicious Script Detection ', ws: 'O', aa: 'X' },
        { capa: 'Malware Infection Detection ', ws: 'O', aa: 'X' },
        { capa: 'Infected Object Identification ', ws: 'O', aa: 'X' },
        { capa: 'Threat & Compromise Visibility ', ws: 'O', aa: 'X' },
        { capa: 'Focus on Live Environments ', ws: 'O', aa: 'Partial' }
      ],
      owasp:[],
      selected:'overview',
      steps:[
        {
          menu: '3.2 Scanner Menu',
          steps:[
            {
              step:`In the 'Scanner' menu, enter the url to scan and the login information for that url.<br>
                    And click 'scan' button to start scan<br>
                    (* Login url, id, pw is only required if it is a page that requires login.)`,
              src:[require('@/assets/enterInfo.png')]
            }, 
            {
              step:'When the scan is complete, the scan results are output below.',
              src:[require('@/assets/scanResult.png')]
            },
            {
              step:'You can view previously scanned results in the history box on the right.',
              src:[require('@/assets/scannerHistory.png')]
            }
          ],
        },{
          menu: '3.3 Scan History Menu',
          steps:[
            {
              step:'In the scan history menu, you can view the history of your scan and the results of your previous scan.',
              src:[require('@/assets/scanHistory.png')]
            },
            {
              step:`Click the view button in the table to view the results of that scan history.`,
              src:[require('@/assets/scanHistoryView.png'), require('@/assets/viewPage.png')]
            },
            {
              step:'Click the download button in the table to download the results of that scan history.',
              src:[require('@/assets/scanHistoryDownload.png'), require('@/assets/downloadPage.png')]
            }
          ],
        }

      ]
    }),
    created(){
      this.owasp=owaspList.owasp
    },
    mounted(){
      var secondMenu= document.getElementById("rule");
      var thirdMenu= document.getElementById('how');
      var fourthMenu= document.getElementById('dev');

      var secondHeight=secondMenu.getBoundingClientRect().top-150;
      var thirdHeight=thirdMenu.getBoundingClientRect().top-200;
      var fourthHeight=fourthMenu.getBoundingClientRect().top-200;

      window.addEventListener("scroll", function(){
        var scrollPosition = window.scrollY;

        this.selected=scrollPosition>=fourthHeight
        ?'dev':scrollPosition>=thirdHeight
        ?'how':scrollPosition>=secondHeight
        ?'rule':'overview';
        console.log(this.selected);
      }.bind(this));
    },
    methods:{
      isText:function(text){
        if(text.startsWith("@")){
          return true
        }else{
          return false;
        }
      },
      changeText: function(text){
        return text.replace("@","- ")
      },
      // changeLocation:function(location){
      //   this.selected=location;
      //   var location1=document.getElementById(location).offsetTop;
      //   document.getElementById("introBox").scrollTo({top:location1, behavior:'smooth'});
      // },
      gotop:function(){
        document.getElementById("introBox").scrollTo({top:0, behavior:'smooth'});
        this.selected='overview';
      }
    },
    // watch:{
    //   selected:{
    //     handler(newVal){
    //       this.selected=newVal;
    //       console.log(newVal);
    //     },
    //     immediate:true
    //   }
    // }
}
</script>

<style scoped>
::v-deep(.v-alert__wrapper){
  align-items: flex-start !important;
}
::v-deep(.v-alert__wrapper button){
  margin-top: -5px !important;
}
.highlight{
  background-color: #B0BEC5 !important;
  font-weight: 500;
  color: white !important;
}
.gotop{
  filter: invert(63%) sepia(40%) saturate(2909%) hue-rotate(359deg) brightness(100%) contrast(108%);
}
.screenshot{
  width: 450px; 
  height: 250px; 
  margin-top: 5px;
}
.comm_bullet{
    font-size:10.5pt;
    font-family:Wingdings;
    mso-fareast-font-family:굴림;
    
    mso-bidi-font-family:Helvetica;
    color:#333333;
    mso-font-kerning:0pt
}
#introBox::-webkit-scrollbar{
  scrollbar-width: none;
  background: transparent;
}

</style>